export function KineticHeadline({ lines, testId = "hero-kinetic-headline" }) {
  return (
    <h1 className="kinetic-headline" data-testid={testId}>
      {lines.map((line, index) => (
        <span className="kinetic-line-mask" key={`${line}-${index}`}>
          <span className={`kinetic-line-inner kinetic-delay-${index + 1}`}>{line}</span>
        </span>
      ))}
    </h1>
  );
}
